import fetchData from "utils/fetchData";
import { useEffect, useMemo, useState } from "react";
import helpers from "utils/helpers";
import { NavLink } from "react-router-dom";
import Preview from "components/Preview";
import { motion, AnimatePresence } from "framer-motion"
import SelectFolder from "components/SelectFolder";
import zip from "utils/zip";

const Document = ({ document, folders, setDocuments, setSelectDocuments, selectDocuments, status, setFile }) => {
    const icon = helpers.mimetype_to_icon(document.mimetype);

    const changeStatus = async e => {
        setDocuments(old => [...old].map(doc => {
            if (doc.id !== document.id) return doc;
            return { ...doc, status: status.find(s => s.id === parseInt(e.target.value)), status_id: e.target.value }
        }));

        const { data, error } = await fetchData({ 
            url: "documents/" + document.id, 
            method: "put",
            body: {
                status_id: e.target.value
            },
            message: "Le status du document a bien été modifié"
        });
        if (error) return console.log(error);
    }

    const is_selected = useMemo(() => {
        return selectDocuments.find(doc => doc.id === document.id)
    }, [document, selectDocuments]);

    const handleSelect = () => {
        if (is_selected) {
            setSelectDocuments(old => [...old].filter(doc => doc.id !== document.id));
        } else {
            setSelectDocuments(old => [...old, document])
        }
    }

    return <motion.div         
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0 }}
            className={is_selected ? "card document selected" : "card document"}
            onClick={handleSelect}
            >
        <div className="document-infos">
            <div onClick={e => {e.stopPropagation(); setFile(document);}}>{icon}</div>

            <div className="document-infos-text">
                <span style={{ width: "fit-content"}}>
                    <NavLink to={"/client/" + document.user.id}><b>{document.user.name}</b></NavLink>
                    <div>| {document.name}</div>
                </span>
                <em>Déposé le {new Date(document.created_at).toLocaleDateString('fr-FR')} | ({document.description})</em>
                <span>
                    {helpers.getPath(document.folders_id, folders).map((item, i) => <p key={i}>
                        <span className="badge badge--small">{item.name}</span>
                    </p>)}
                </span>

            </div>
        </div>
        <span className="document-actions">
            <select onClick={e => e.stopPropagation()} onChange={changeStatus} value={document.status.id}>
                {status.map(item => <option key={item.id} value={item.id}>{item.title}</option>)}
            </select>

        </span>

    </motion.div>
}

const Panel = () => {
    const initial_options = {
        user: "",
        status: "",
        folder: ""
    }

    const [documents, setDocuments] = useState([]);
    const [folders, setFolders] = useState([]);
    const [clients, setClients] = useState([]);
    const [options, setOptions] = useState({ ...initial_options });
    const [status, setStatus] = useState([]);
    const [file, setFile] = useState(null);
    const [selectDocuments, setSelectDocuments] = useState([]);

    useEffect(() => {
        const get_documents = async () => {
            const { data, error } = await fetchData({ url: "documents" });
            if (!error) setDocuments(data);
        }

        const get_folders = async () => {
            const { data, error } = await fetchData({ url: "folders" });
            if (!error) setFolders(data);
        }

        const get_clients = async () => {
            const { data, error } = await fetchData({ url: "users?roles_id=1" });
            if (!error) setClients(data);
        }

        const get_status = async () => {
            const { data, error } = await fetchData({ url: "status" });
            if (!error) {
                setStatus(data);
                setOptions({...options, status: data[0].id})
            }
            get_documents();
        }

        get_folders();
        get_clients();
        get_status();
    }, []);

    const DisplayDocuments = () => {
        return documents.filter(doc => {
            if (doc.user.roles_id !== 1) return false;
            if (doc.user.id !== options.user && options.user !== "") return false;
            if (doc.status.id !== options.status && options.status !== "") return false;
            if (doc.folders_id !== options.folder && options.folder !== "") return false;
            return true;
        }).sort((b, a) => new Date(a.created_at) - new Date(b.created_at)).map(doc => <Document
            key={doc.id}
            status={status}
            folders={folders}
            document={doc}
            documents={documents}
            setDocuments={setDocuments}
            file={file}
            setFile={setFile}
            setSelectDocuments={setSelectDocuments}
            selectDocuments={selectDocuments}
        />)
    }

    const downloadZip = () => {
        const urls = selectDocuments.map(doc => `https://drive.google.com/u/0/uc?id=${doc.drive_key}&export=download`);

        zip(urls);
    }

    return <div className="page">
        <aside>
            {(selectDocuments.length > 1) && <button onClick={downloadZip}>
                Télécharger les {selectDocuments.length} documents
            </button>}

            {(selectDocuments.length === 1) && <a 
                href={`https://drive.google.com/u/0/uc?id=${selectDocuments[0].drive_key}&export=download`}>
                    <button>Télécharger le document </button>
                </a>}

            <form style={{ width: 280 }} className="card">
                
                <div className="group">
                    <label>Client</label>
                    <select onChange={e => setOptions({ ...options, users_id: e.target.value })} value={options.users_id}>
                        <option value={""}></option>
                        {clients.map((client) => <option key={client.id} value={client.id}>{client.name}</option>)}
                    </select>
                </div>


                <div className="group">
                    <label>Dossier</label>
                    <SelectFolder folder={options.folder} setFolder={item => setOptions({ ...options, folder: item })} />
                </div>

                <div className="group">
                    <label>Type de document</label>
                    <div>
                        {[{id: "", title: "tous"}, ...status].map(s => <div key={s.id} className="radio">
                            <input onChange={() => setOptions({ ...options, status: s.id })} htmlFor={"radio-" + s.id} name="radio" type="radio" checked={(options.status === s.id)} />
                            <label onClick={() => setOptions({ ...options, status: s.id })} id={"radio-" + s.id} className="radio-label">
                                {s.title} <a className={"grey"}>({documents.filter(doc => (doc.user.roles_id === 1) && (doc.status.id === s.id || s.id === "")).length})</a>
                            </label>
                        </div>)}
                    </div>
                </div>
            </form>
        </aside>
        <main>
            <div className="documents">
          
                <DisplayDocuments />
                
                <Preview file={file} setFile={setFile} />
            </div>

        </main>

    </div>
}

export default Panel;